import React, { useState } from 'react';
import './InfoBar.css';
import { updateAchievementVideoStatus } from '../../../api/VideoInteractions/videoInteractions';
import { toast } from 'react-toastify';
import ResponseStatus from '../../../enums/ResponseStatus';

export default function InfoBar({ videoId, videoTitle, initialStatus, token,userRole }) {
  const [selectedStatus, setSelectedStatus] = useState(initialStatus || null);
  const [isLoading, setIsLoading] = useState(false);

  const handleAction = async (status) => {
    setIsLoading(true);
    try {
      const res = await updateAchievementVideoStatus(token, {
        AchievementVideoId: videoId,
        Status: status,
      });

      if (res?.data?.ResponseStatus === ResponseStatus.Success) {
        setSelectedStatus(status);
      } else {
        toast.error(res?.data?.ResponseMessage || 'İşlem başarısız oldu.');
      }
    } catch {
      toast.error('Bir hata oluştu, lütfen tekrar deneyin.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ham-infobar">
      <div className="ham-infobar-title">{videoTitle}</div>
      <div className="ham-infobar-actions">
        {userRole === "superAdmin" && selectedStatus !== 1 && (
          <button
            className="ham-infobar-btn ham-infobar-btn--approve"
            onClick={() => handleAction(1)}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="ham-infobar-spinner" />
            ) : (
              'Onayla'
            )}
          </button>
        )}
        {userRole === "superAdmin" && selectedStatus !== 2 && (
          <button
            className="ham-infobar-btn ham-infobar-btn--reject"
            onClick={() => handleAction(2)}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="ham-infobar-spinner" />
            ) : (
              'Reddet'
            )}
          </button>
        )}
      </div>
    </div>
  );
}
